import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { CircularProgress, Fade } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import moment from 'moment';
import Cookies from 'universal-cookie';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { NotificationManager } from 'react-notifications';
import { Redirect, withRouter } from 'react-router-dom';
import StarRatings from 'react-star-ratings';

class RatingPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderButton: false,
            otp: '',
            otpError: '',
            dashboardRedirect: false,
            playerId: '',
            r1: 1,
            r2: 1,
            r3: 1,
            ar: 1,
            review: '',
            reviewError: ''
        };
    }

    handleClose = () => {
        this.props.close();
    };

    renderButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <Button
                    variant="contained"
                    style={{
                        backgroundColor: this.props.theme.palette.primary.main,
                        color: '#ffffff',
                        fontSize: '16px'
                    }}
                    size="large"
                    onClick={() => this.addRatingActionCall()}
                >
                    Done
                </Button>
            );
        }
    };

    addRatingActionCall = () => {
        const { r1, r2, r3, review } = this.state;

        this.setState({ loaderButton: true });
        this.props.rateBookingAction(
            {
                r1: r1,
                r2: r2,
                r3: r3,
                review: review,
                bookingToken: this.props.bookingToken
            },
            this.onDone
        );
    };
    handleError = params => {
        this.setState(params);
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({
                loaderButton: false
            });
            NotificationManager.success('Rating Added Successfully', 'Success');
            this.handleClose();
            this.props.reviewDone();
        } else {
            this.setState({
                loaderButton: false
            });
            NotificationManager.error('Some error found', 'Error');
        }
    };
    changeRating = (newRating, name) => {
        this.setState(
            {
                [name]: newRating
            },
            () => {
                this.calculateAverageRating();
            }
        );
    };
    calculateAverageRating = () => {
        const avg = (this.state.r1 + this.state.r2 + this.state.r3) / 3;

        this.setState({ ar: avg });
    };
    render() {
        const { review, reviewError } = this.state;
        if (this.state.dashboardRedirect) {
            this.props.history.push({
                pathname: `/user/dashboard`
            });
            // return (
            //     <Redirect
            //         to={{
            //             pathname: `/user/dashboard`
            //         }}
            //     />
            // );
        }
        return (
            <div>
                <Dialog
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="text-center"
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <form className="dialog-form">
                        <div
                            className="dialog-header"
                            style={{
                                backgroundColor: this.props.theme.palette
                                    .primary.main
                            }}
                        >
                            <h3 className="dialog-heading">Rate the service</h3>
                        </div>
                        <div className="dialog-body">
                            <DialogContent>
                                <h4>{this.props.arValue}</h4>
                                <StarRatings
                                    rating={this.state.ar}
                                    starDimension="40px"
                                    starSpacing="15px"
                                    starRatedColor={this.props.starRatedColor}
                                />
                                <br />
                                <br />
                                <div className="text-center">
                                    <h4>{this.props.r1Value}</h4>
                                    <StarRatings
                                        rating={this.state.r1}
                                        starRatedColor={
                                            this.props.starRatedColor
                                        }
                                        changeRating={this.changeRating}
                                        numberOfStars={5}
                                        name="r1"
                                        starDimension="40px"
                                        starSpacing="15px"
                                        starHoverColor={
                                            this.props.starRatedColor
                                        }
                                    />
                                </div>

                                <div className="text-center">
                                    <h4>{this.props.r2Value}</h4>
                                    <StarRatings
                                        rating={this.state.r2}
                                        starRatedColor={
                                            this.props.starRatedColor
                                        }
                                        changeRating={this.changeRating}
                                        numberOfStars={5}
                                        name="r2"
                                        starDimension="40px"
                                        starSpacing="15px"
                                        starHoverColor={
                                            this.props.starRatedColor
                                        }
                                    />
                                </div>
                                <div className="text-center">
                                    <h4>{this.props.r3Value}</h4>
                                    <StarRatings
                                        rating={this.state.r3}
                                        starRatedColor={
                                            this.props.starRatedColor
                                        }
                                        changeRating={this.changeRating}
                                        numberOfStars={5}
                                        name="r3"
                                        starDimension="40px"
                                        starSpacing="15px"
                                        starHoverColor={
                                            this.props.starRatedColor
                                        }
                                    />
                                </div>
                                <TextField
                                    error={reviewError ? true : false}
                                    helperText={reviewError}
                                    label="Review"
                                    id="review"
                                    fullWidth={true}
                                    name="review"
                                    type="text"
                                    value={review}
                                    onChange={event => {
                                        this.setState({
                                            review: event.target.value,
                                            reviewError: ''
                                        });
                                    }}
                                />
                            </DialogContent>

                            <DialogActions>
                                <div className="col-md-12">
                                    {this.renderButton()}
                                </div>
                            </DialogActions>
                        </div>
                    </form>
                </Dialog>
            </div>
        );
    }
}

const composedHOC = compose(
    withTheme(),

    connect(
        null,
        actions
    )
);
export default composedHOC(withRouter(RatingPopup));



// WEBPACK FOOTER //
// ./src/components/Customer/RatingPopup.jsx